import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LogoMark } from "@/components/AuthShell";
import { api } from "@/lib/api";

export const MaintenanceGate = ({ children }) => {
  const [m, setM] = useState(undefined);
  useEffect(() => { api.get("/public/maintenance").then(({ data }) => setM(data)).catch(() => setM(null)); }, []);
  if (m === undefined) return null;
  if (!m?.active) return children;
  return (
    <div className="min-h-screen bg-[#0b1220] text-white grid place-items-center px-6" data-testid="maintenance-page">
      <div className="max-w-lg text-center">
        <div className="flex items-center justify-center gap-3 mb-10"><LogoMark className="h-12 w-12" /><span className="text-2xl font-extrabold tracking-tight">ScreenView</span></div>
        <div className="mx-auto h-14 w-14 rounded-full bg-sky-400/15 grid place-items-center mb-6"><Wrench className="h-6 w-6 text-sky-300" /></div>
        <h1 className="text-3xl sm:text-4xl font-bold mb-4">Maintenance en cours</h1>
        <p className="text-slate-300 whitespace-pre-line mb-10" data-testid="maintenance-message">{m.message}</p>
        <Button asChild size="lg" className="rounded-full font-bold"><Link to="/login" data-testid="maintenance-login-btn">Se connecter à mon espace</Link></Button>
        <p className="text-xs text-slate-500 mt-6">Les postes équipés de l'agent et les sessions d'assistance continuent de fonctionner.</p>
      </div>
    </div>
  );
};
